import { Routes } from '@angular/router'
import { ErrorV1Component } from '@views/pages/speciality/error-v1/error-v1.component'
import { ErrorV2Component } from '@views/pages/speciality/error-v2/error-v2.component'

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@views/for-guests/for-guests').then(
        (mod) => mod.ForGuestsComponent
      ),
    data: { title: 'For Guests' },
  },
  {
    path: 'for-service-providers',
    loadComponent: () =>
      import(
        '@views/for-service-providers/for-service-providers.component'
      ).then((mod) => mod.ForServiceProvidersComponent),
    data: { title: 'For Service Providers' },
  },
  {
    path: 'for-property-operators',
    loadComponent: () =>
      import(
        '@views/for-property-operators/for-property-operators.component'
      ).then((mod) => mod.ForPropertyOperatorsComponent),
    data: { title: 'For Property Operators' },
  },
  {
    path: 'become-a-partner',
    loadComponent: () =>
      import('@views/become-a-partner/become-a-partner.component').then(
        (mod) => mod.BecomeAPartnerComponent
      ),
    data: { title: 'Become a Partner' },
  },
  {
    path: 'sign-in',
    loadComponent: () =>
      import('@views/sign-in/sign-in.component').then(
        (mod) => mod.SignInComponent
      ),
    data: { title: 'Sign In' },
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('@views/terms-and-conditions/terms-and-conditions.component').then(
        (mod) => mod.TermsAndConditionsComponent
      ),
    data: { title: 'Terms & Conditions' },
  },
  /* {
    path: 'landings',
    component: LandingLayoutComponent,
    loadChildren: () =>
      import('@views/landings/landings.route').then(
        (mod) => mod.LANDING_ROUTES
      ),
  },
  {
    path: 'about',
    component: LandingLayoutComponent,
    loadChildren: () =>
      import('@views/pages/about/about.route').then((mod) => mod.ABOUT_ROUTES),
  },
  {
    path: 'blog',
    component: LandingLayoutComponent,
    loadChildren: () =>
      import('@views/pages/blog/blog.route').then((mod) => mod.BLOG_ROUTES),
  },
  {
    path: 'portfolio',
    component: LandingLayoutComponent,
    loadChildren: () =>
      import('@views/pages/portfolio/portfolio.route').then(
        (mod) => mod.PORTFOLIO_ROUTES
      ),
  },
  {
    path: 'services',
    loadChildren: () =>
      import('@views/pages/services/service.route').then(
        (mod) => mod.SERVICE_ROUTE
      ),
  },
  {
    path: 'contacts',
    component: LandingLayoutComponent,
    loadChildren: () =>
      import('@views/pages/contacts/contact.route').then(
        (mod) => mod.CONTACT_ROUTES
      ),
  },
  {
    path: 'pages/pricing',
    component: PricingComponent,
    data: { title: 'Pricing' },
  }, */
  {
    path: 'errors/404-1',
    component: ErrorV1Component,
    data: { title: '404 Not Found v1' },
  },
  {
    path: 'errors/404-2',
    component: ErrorV2Component,
    data: { title: '404 Not Found v2' },
  },
  /* {
    path: 'account',
    canActivate: [AuthGuard],
    component: AccountLayoutComponent,
    loadChildren: () =>
      import('@views/account/accounts.route').then((mod) => mod.ACCOUNT_ROUTES),
  },
  {
    path: 'account/sign-in',
    component: SigninComponent,
    data: { title: 'Account - Sign In' },
  },
  {
    path: 'account/sign-up',
    component: SignupComponent,
    data: { title: 'Account - Sign Up' },
  }, */
]
